'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addSeconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/addSeconds.js
// module id = 244
// module chunks = 0